import gql from "graphql-tag";
import { graphql, compose } from "react-apollo";

export const getCallReportsQuery = gql `
  query callReports ($filterBy: [JSONString], $offset: Int = 0, $pageSize: Int = 10, $sort: [JSONString]) {
    callReports (filterBy: $filterBy, offset: $offset, pageSize: $pageSize, sort: $sort) {
      callReports {
        crId
        user {
          username
        }
        description
        pin1 {
          pin
        }
        pid
        createdAt
      }
      pages
    }
  }
`

export const getCallReport = gql`
  query report($crid: Int!) {
    report (crid: $crid) {
      dataJson
      user {
        username
      }
      pin1 {
        project {
          name
        }
      }
      createdAt
      description
    }
  } 
`


// WEBPACK FOOTER //
// ./src/views/reports/graph.js